import { render, staticRenderFns } from "./Point_IoT.vue?vue&type=template&id=2618f0b2"
import script from "./Point_IoT.vue?vue&type=script&lang=js"
export * from "./Point_IoT.vue?vue&type=script&lang=js"
import style0 from "./Point_IoT.vue?vue&type=style&index=0&id=2618f0b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports